import React, { useEffect, useState } from 'react';
import WordCard from './wordCard';
import { Container } from '@mui/material';
import AuthPathConstants from '../../constants/AuthPath.constants';
import img from '../../assets/img/completed.png';
var CardList = function (_a) {
    var page = _a.page, group = _a.group, color = _a.color, updateAllLearned = _a.updateAllLearned, allLearned = _a.allLearned;
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), isLoaded = _c[0], setIsLoaded = _c[1];
    var _d = useState([]), items = _d[0], setItems = _d[1];
    var _e = useState(0), changed = _e[0], setChanged = _e[1];
    var change = function () {
        setChanged(function (changed) { return (changed += 1); });
    };
    useEffect(function () {
        if (group === 7) {
            var NonStringedUser = localStorage.getItem('userInfo');
            var user = JSON.parse(NonStringedUser);
            var token = user.token;
            fetch(AuthPathConstants.BASE +
                AuthPathConstants.USERS +
                "/".concat(user.userId) +
                AuthPathConstants.AGGREGATED_WORDS +
                "?wordsPerPage=600&" +
                AuthPathConstants.FILTER_BY_HARD, {
                headers: {
                    Authorization: "Bearer ".concat(token),
                    Accept: 'application/json',
                },
            })
                .then(function (res) { return res.json(); })
                .then(function (result) {
                setIsLoaded(true);
                setItems(result[0].paginatedResults);
            }, function (error) {
                setIsLoaded(true);
                setError(error);
            });
        }
        else {
            if (localStorage.userInfo) {
                var NonStringedUser = localStorage.getItem('userInfo');
                var user = JSON.parse(NonStringedUser);
                var token = user.token;
                fetch(AuthPathConstants.BASE +
                    AuthPathConstants.USERS +
                    "/".concat(user.userId) +
                    AuthPathConstants.AGGREGATED_WORDS +
                    '?' +
                    "wordsPerPage=20&group=".concat(group - 1, "&page=").concat(page - 1), {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                        Accept: 'application/json',
                    },
                })
                    .then(function (res) { return res.json(); })
                    .then(function (result) {
                    setIsLoaded(true);
                    setItems(result[0].paginatedResults);
                }, function (error) {
                    setIsLoaded(true);
                    setError(error);
                });
            }
            else {
                fetch(AuthPathConstants.BASE +
                    AuthPathConstants.WORDS +
                    '?' +
                    "group=".concat(group - 1, "&page=").concat(page - 1))
                    .then(function (res) { return res.json(); })
                    .then(function (result) {
                    setIsLoaded(true);
                    setItems(result);
                }, function (error) {
                    setIsLoaded(true);
                    setError(error);
                });
            }
        }
    }, [group, page, changed]);
    if (localStorage.userInfo &&
        items.filter(function (item) {
            return item.userWord &&
                item.userWord.optional &&
                item.userWord.optional.isKnown === true;
        }).length === 20) {
        updateAllLearned(true);
    }
    else {
        updateAllLearned(false);
    }
    if (error) {
        return React.createElement("div", null,
            "\u041E\u0448\u0438\u0431\u043A\u0430: ",
            error);
    }
    else if (!isLoaded) {
        return React.createElement("div", null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    }
    else {
        return (React.createElement(Container, { maxWidth: "xl", sx: {
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                backgroundImage: allLearned ? "url(".concat(img, ")") : 'none',
                backgroundSize: 'contain',
            } }, items.map(function (item) { return (React.createElement(WordCard, { props: item, key: item.word, color: color, group: group, change: change })); })));
    }
};
export default CardList;
